import React from "react";
import { Container, TextField, Card, CardContent, Typography, Box, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import useFetch from "../utils/UseFetch";
import { Buffer } from 'buffer';
import { useNavigate } from "react-router-dom";

const REACT_APP_API_USERNAME = process.env.REACT_APP_API_USERNAME;
const REACT_APP_API_PASSWORD = process.env.REACT_APP_API_PASSWORD;
const REACT_APP_COMPANY = process.env.REACT_APP_COMPANY;
const REACT_APP_API_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_UNAME = REACT_APP_API_USERNAME;

const REACT_PWD = REACT_APP_API_PASSWORD;

const REACT_DATA_URL = REACT_APP_API_DATA_URL;

const REACT_APP_COMPANY_URL = REACT_APP_COMPANY;


const eq = ' eq ';
const filter = '?$filter =';

const ArchivedBidList = () => {
  //itemsApi
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');

  const { data: itemsLines, loading, error } = useFetch(`${REACT_DATA_URL}RFPHeader?${REACT_APP_COMPANY_URL}&$filter = Status eq Closed`, token);
  // const { data: customer, loading, error } = useFetch(customerLink, token);
  //console.log(itemsLines);
  const navigate = useNavigate();
  const itemsData = itemsLines?.value;
  
  console.log(itemsData);

  const handleLinkClick = (bid) => {
    navigate(`/bid-view`, { state: { bidNo: bid.title, bidDescription: bid.description, bidDueDate: bid.dueDate, bidProcurementMethod: bid.procurementMethod, bidPostingDate: bid.postingDate, from:'archived'} });
    // const username = sessionStorage.getItem('username');
    // if (username) {
    //   navigate(`/bid-view`, { state: { bidNo: bid.title, bidDescription: bid.description } });
    // } else {
    //   alert("Please log in to view bid details.");
    // }
  };

  const demoBids = [
    ...(itemsData ? itemsData
      .filter(item => item.procurementMethod === "Open_x0020_Tender")
      .map(item => ({
        title: item.no,
        description: item.description,
        dueDate: item.validToDate || "N/A",
        procurementMethod: item.procurementMethod.replace(/_x0020_/g, ' '),
        postingDate: item.postingDate || "N/A",
      })) : [])
  ];

  const [searchTerm, setSearchTerm] = React.useState("");

  const filteredBids = demoBids.filter(bid =>
    bid.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    bid.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 4, ml: 0 }}>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search bids..."
        sx={{ mb: 3 }}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      {filteredBids.map((bid, index) => (
        <Card key={index} sx={{ mb: 2, width: "100%", height: "100px" }}>
          <CardContent>
            <Typography variant="h6" color="primary" sx={{ fontSize: 15 }}>
            {/* {state: {number: row.no}} */}
              <a onClick={() => handleLinkClick(bid)} style={{ cursor: "pointer" }}>
                {bid.title}
              </a>
            </Typography>
            <Typography variant="body1" sx={{ mt: 0 }}>
              {bid.description}
            </Typography>
            <Box sx={{ mt: 1, fontStyle: "italic", color: "gray" }}>
              End Date: {bid.dueDate}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Container>
  );
};

export default ArchivedBidList;
